// routes/extraRoutes.js
import EmployeeWorkspace from "pages/EmployeeWorkspace";
import RequirePermission from "routes/RequirePermission";
import { ROUTES } from "config";
import MyDataSheetRedirect from "routes/MyDataSheetRedirect";
import { PageNotFound } from "pages/PageNotFound";

const extraRoutes = [
    {
        path: ROUTES.EMPLOYEE(),
        element: (
            <RequirePermission
                requiredPermissions={["employee.view", "payrollEmployee.view"]}
            >
                <EmployeeWorkspace />
            </RequirePermission>
        )
    },
    {
        path: ROUTES.EMPLOYEES_NEW,
        element: (
            <RequirePermission requiredPermissions={["employee.view"]}>
                <EmployeeWorkspace />
            </RequirePermission>
        )
    },
    {
        path: ROUTES.MY_PROFILE,
        element: (
            <RequirePermission requiredPermissions={["all"]}>
                <MyDataSheetRedirect />
            </RequirePermission>
        )
    },
    {
        path: "*",
        element: <PageNotFound /> // catch-all inside protected section
    }
];

export default extraRoutes;
